// extracted by mini-css-extract-plugin
module.exports = {"badge":"PriorityServicesBadge_badge__A7dqr"};